<!-- =========================================================================================
    File Name: ChangeTimeDurationDropdown.vue
    Description: Change duration dropdown component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer">
    <small class="flex cursor-pointer">
      <span>{{ title }}</span>
      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
    </small>
    <vs-dropdown-menu class="w-32">
      <vs-dropdown-item
        :color="'danger'"
        v-for="(time, index) in times"
        :key="index"
        @click="handleClick(time)"
        >{{ time.value }}</vs-dropdown-item
      >
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  data() {
    return {
      title: "All",
      times: [
        {
          key: "all_time",
          value: "All"
        },
        {
          key: "month",
          value: "Month"
        },
        {
          key: "quarter",
          value: "Quarter"
        },
        {
          key: "year",
          value: "Year"
        }
      ]
    };
  },
  methods: {
    handleClick(time) {
      this.title = time.value;
      this.$listeners.timeDurationChanged(time.key);
    }
  }
};
</script>
